<template>
  <div class="comment-list-wrap">
    <modal></modal>
    <comment-input v-if="$pageType === 'comment' && entryID > 0"></comment-input>
    <ul id="commentList" class="comment-list">
      <li class="comment-list__item" v-for="(comment, index) in comments" :key="index">
        <comment :comment="comment" :i="index"></comment>
        <reply-comment-list
          :replyComments="comment.reply"
          :replyPager="comment.replyPager"
          :replyKey="comment.uuid"
          :i="index"
          v-if="isShowReplyComment(comment)"
        ></reply-comment-list>
      </li>
    </ul>
    <page-nation v-if="$pageType === 'comment'"></page-nation>
  </div>
  <!-- /.comment-list-wrap -->
</template>

<script>
import commentInput from '../../organisms/commentInput/commentInput'
import comment from '../../organisms/comment/comment'
import replyCommentList from '../../organisms/replyCommentList/replyCommentList'
import modal from '../../molecules/modal/modal'
import pageNation from '../../molecules/pageNation/pageNation'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'commentList',
  components: {
    comment: comment,
    'reply-comment-list': replyCommentList,
    'comment-input': commentInput,
    modal: modal,
    'page-nation': pageNation
  },
  watch: {
    $route (to, from) {
      // コメント設定
      this.commentInit()
    }
  },
  mounted: function () {
    // this.$nextTick(function () {
    //   const oldCommentElm = document.querySelector('.old-comment')
    //   oldCommentElm.classList.add('old-comment-first')
    //   console.log(oldCommentElm)
    // })
    // 追加要素のアニメーション リスナー 動かない
    // const activeElm = document.querySelectorAll('.active')
    // console.log(activeElm, 'activeElm')
    // activeElm.forEach(function (item, i) {
    //   console.log('active')
    //   item.addEventListener('transitionend', function () {
    //     console.log(i)
    //   })
    // })

    // ユーザーデータ取得
    // localstrageを使用する
    window.addEventListener('userDataCallback', this.userDataGet, false)

    // entry_id取得
    const entryID = document
      .getElementsByName('cXenseParse:recs:articleid')
      .item(0).content
    this.setEntryId(entryID)
    // コメント設定
    // 記事ページの場合はid："entryComment"が画面内に表示されたら
    this.commentInit()
  },
  computed: {
    ...mapState('commentsData', ['entryID', 'comments'])
  },
  methods: {
    ...mapActions('commentsData', [
      'commentsGet',
      'entryDataSet',
      'setEntryId'
    ]),
    ...mapActions('userData', ['userDataGet']),
    isShowReplyComment (comment) {
      return comment.commentView.replyShowFlag
    },
    commentInit: function () {
      // 記事URL取得
      const entryUrl = document.getElementsByName('cXenseParse:url').item(0)
        .content
      // 記事タイトル取得
      const entryTitle = document
        .getElementsByName('cXenseParse:jct-title')
        .item(0).content
      // entry_id取得
      const entryID = document
        .getElementsByName('cXenseParse:recs:articleid')
        .item(0).content

      // entry_idが取得出来なかったら
      if (!entryID) {
        return
      }

      const page = {
        entry: 1,
        comment: this.$route
          ? this.$route.params.page
            ? Number(this.$route.params.page.replace('page', ''))
            : 1
          : 1
      }

      // コメント一覧取得
      const payload = {
        page: page[this.$pageType],
        entry_id: entryID,
        pageType: this.$pageType
      }
      // 記事ページの場合はid："entryComment"が画面内に表示されたら
      this.commentsGet(payload)
      this.entryDataSet({ entry_url: entryUrl, entry_title: entryTitle })
      this.metaSetData()
    },
    metaSetData: function () {
      // meta
      const isRouter = this.$route !== undefined
      // console.log(isRouter, 'isRouter')
      // ルーター使用時
      if (isRouter) {
        // ページ
        let page = this.$route.page || 'page1'
        const pageCurren = Number(page.replace('page', ''))
        // チャンネル取得
        const entryChannel =
          document.getElementsByName('cXenseParse:jct-channel').item(0)
            .content || 'ニュース'
        // 記事タイトル取得
        const entryTitle =
          document.getElementsByName('cXenseParse:jct-title').item(0).content ||
          '記事タイトル'
        // title 変更
        let thisTitle =
          'コメント' +
          pageCurren +
          'ページ｜' +
          entryTitle +
          '：' +
          'J-CAST' +
          entryChannel
        document.title = thisTitle
      }
    }
  }
}
</script>

<style lang="scss" src="./commentList.scss"></style>



// WEBPACK FOOTER //
// src/components/tmplate/commentList/commentList.vue